﻿import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { WizardViewModel } from '../app/components/wizards/dentally/wizard-view-model';

@Injectable()
export class AuthMsgService {
    private subject = new BehaviorSubject<boolean>(false);
    private hideSideNavSubject = new BehaviorSubject<boolean>(true);

    sendMessage(message: boolean) {
        this.subject.next(message);
    }

    clearMessage() {
        this.subject.next(false);
    }

    getMessage(): Observable<boolean> {
        return this.subject.asObservable();
    }

    hideSideNav(show: boolean) {
        this.hideSideNavSubject.next(show);
    }

    sideNavHidden(): Observable<boolean> {
        return this.hideSideNavSubject.asObservable();
    }

    sideNavCurrenVisiblity(): boolean {
        return this.hideSideNavSubject.getValue();
    }
}